import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "lib/query/queryClient";
import * as React from "react";
import type { ComponentType, ReactNode } from "react";
import lazySuspense from "ui/hooks/lazySuspense";

const ReactQueryDevtoolsProduction = lazySuspense(
  () =>
    // The production build types ReactQueryDevtools as a union (it includes a
    // tree-shaken stub), which lazySuspense's generic can't infer. We render it
    // without props, so narrow the resolved module to a plain ComponentType.
    import("@tanstack/react-query-devtools/build/modern/production.js").then((d) => ({
      default: d.ReactQueryDevtools,
    })) as Promise<{ default: ComponentType }>,
  { fallback: null },
);

export default function ReactQueryProvider({ children }: { children: ReactNode }) {
  const [showDevtools, setShowDevtools] = React.useState(false);
  React.useEffect(() => {
    // @ts-expect-error - this is a global function that is used to toggle the devtools as recommended by React Query Devtools documentation
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevtools && <ReactQueryDevtoolsProduction />}
    </QueryClientProvider>
  );
}
